export const getIsLoading = (state) => state.home.isApiLoading;
export const getProfileInformation = (state) => state.home.profileInformation;
export const getToken = (state) => state.home.token;